import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";
import { useLang } from "../i18n";

export const EditorialMarquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div data-testid="editorial-marquee" className="bg-coal text-sand/90 py-6 md:py-8 border-y border-coal2 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {[...items, ...items].map((item, i) => (
          <span key={i} className="marquee-item font-serif italic text-2xl md:text-4xl font-light">
            {item}
            <Sparkle className="w-4 h-4 text-ember" strokeWidth={1.5} />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
